import React from 'react';

const CustomerCard = ({ customer }) => {
    return (    
        <tr>
            <td>
                <div className="d-flex px-2 py-1">
                    <div>
                        <img src={"../assets/img/"+customer.icon} className="avatar avatar-sm me-3 border-radius-lg" alt="user1"/>
                    </div>
                    <div className="d-flex flex-column justify-content-center">
                        <h6 className="mb-0 text-sm">{customer.firstName}</h6>
                        <p className="text-xs text-secondary mb-0">{customer.lastName}</p>
                    </div>
                </div>
            </td>
            <td>
                <p className="text-xs font-weight-bold mb-0">{customer.email}</p>
                <p className="text-xs text-secondary mb-0">{customer.city}</p>
            </td>
            <td className="align-middle text-center text-sm">
                {customer.activeFlag ? 
                <span className="badge badge-sm bg-gradient-success">
                Yes
                </span>
                :
                <span className="badge badge-sm bg-gradient-danger">
                No
                </span>
}
            </td>
            <td className="align-middle text-center">
                <span className="text-secondary text-xs font-weight-bold">
                {customer.entryDate.split('T')[0].split('-').reverse().join('/')}
                    </span>
            </td>
            <td className="align-middle">
                <a href="#" className="text-secondary font-weight-bold text-xs" data-toggle="tooltip" data-original-title="Edit user">
                    Edit
                </a>
            </td>
        </tr>
    );
}

export default CustomerCard;